import { FormControl, FormGroup } from '@angular/forms';
import { FundOrderSellComponentControls, FundOrderSellControlsInterface } from 'appAssets/descriptors';

export class FundOrderSellForm {
    public form: FormGroup;
    public controls: FundOrderSellControlsInterface;

    initForm(isMutualFund: boolean): void {
        this.form = new FormGroup({});
        this.controls = FundOrderSellComponentControls(isMutualFund);

        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];
            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }

    validateForm(messageFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        if (this.form.invalid) {
            Object.keys(this.controls).forEach((key: string) => {
                const control = this.controls[key];
                const formControl = this.form.get(control.name);

                if (formControl && formControl.invalid) {
                    control.errors = Object.keys(formControl.errors).map((errorKey: string) => {
                        return messageFunction(control.placeholder)[errorKey];
                    });
                }
            });

            return false;
        }

        return true;
    }
}
